var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import Card from 'src/components/Card/Card';
import LineGraph from 'src/components/Graphs/LineGraph.vue';
import { sortBy, uniq } from 'lodash';
import rpc from 'src/api/rpc';
import rowMenuItemShowReservationsList from './rowMenuItemShowReservationsList.vue';
import getDisplayValue from 'src/components/GenericTable/utils/getDisplayValue';
import getRecords from 'src/utils/entityOperations/getRecords';
export default Vue.extend({
    components: { Card, LineGraph, rowMenuItemShowReservationsList },
    props: {
        row: { type: Object, default: null, required: true },
        col: { type: Object, default: null, required: true },
        benchmarkClassIdsProp: { type: Array, default: null },
        fieldIsClassIdProp: { type: Boolean, default: false },
        // eslint-disable-next-line vue/prop-name-casing
        class_metric_ids_prop: { type: Array, default: () => null }
    },
    data() {
        return {
            visible: true,
            historyData: [],
            class_metric_ids_data: []
        };
    },
    computed: {
        seriesZeroTo170() {
            const res = [];
            for (let i = 0; i < 171; i++)
                res.push(i);
            return res;
        },
        classMetrics() { return getRecords('ci.class_metrics'); },
        gridProp() {
            return {
                top: '30px',
                left: '40px',
                right: '20px',
                bottom: '30px'
            };
        },
        sortedHistoryData() {
            return sortBy(this.historyData, ['display_order']).filter(r => this.class_metric_ids_data.includes(Number(r.metric_id)));
        },
        metricGroups() {
            return [
                { label: 'Expected check-ins', metricIds: [1, 4, 5, 6, 22] },
                { label: 'Expected Total<br>Attendance', description: 'Total Attendance = Check-ins + Penalty Cancels + Penalty No-Shows', metricIds: [35, 36] },
                { label: 'Actual bookings<br>minus cancels and noshows', metricIds: [13, 14, 15] },
                // { label: 'Expected final<br>late cancels and noshows', metricIds: [31, 32, 33, 34, 29] },
                { label: 'Cancels and noshows', metricIds: [19, 20, 21, 31, 32, 33, 34, 29, 37] },
                { label: 'Broker availability', metricIds: [3, 8, 9, 23] },
                { label: 'Broker price', metricIds: [10, 11, 12] },
                { label: 'Other', metricIds: [7, 24, 25] }
            ];
        }
    },
    watch: {
        'col.field': {
            immediate: true,
            handler(newVal) {
                if (this.class_metric_ids_prop) {
                    return;
                }
                this.class_metric_ids_data.push((this.classMetrics.find(r => r.ci_classes_field === newVal) || {}).id || 13); /* bookings minus cancels and noshows */
            }
        },
        'class_metric_ids_data': {
            immediate: true,
            handler(newVal) {
                var _a;
                return __awaiter(this, void 0, void 0, function* () {
                    // there must be a metric IDs, otherwise the query tooks forever as the data source is a remote
                    // FDW postgres table, so the more specific conditions we get the quicker will be the response
                    if (newVal.length > 0) {
                        // if (this.class_metric_ids_data.length === 0) throw new Error('No metrics specified')
                        this.visible = true;
                        let classIds = [this.row.id];
                        if (this.benchmarkClassIdsProp)
                            classIds = classIds.concat(this.benchmarkClassIdsProp);
                        const response = yield rpc('ci.class_metric_history_fetch', { class_ids: classIds, class_metric_ids: this.class_metric_ids_data });
                        for (const serie of response) {
                            const data = [];
                            for (const h of this.seriesZeroTo170) {
                                data.push((_a = serie.data_in_hbcs_value_form.find((r) => r.hbcs === h)) === null || _a === void 0 ? void 0 : _a.value);
                            }
                            serie.data = data;
                        }
                        this.$set(this, 'historyData', response);
                    }
                });
            }
        },
        class_metric_ids_prop: {
            immediate: true,
            handler(newVal) { if (newVal)
                this.class_metric_ids_data = newVal; }
        },
        visible(newVal) { if (!newVal)
            this.$emit('unloadComponent'); }
    },
    methods: {
        getSubHeading(row) {
            return row.location_id_display_value + ' ' +
                getDisplayValue({ name: '', field: 'start_date', isDate: true }, { id: 0, start_date: row.start_date }) + ' ' +
                getDisplayValue({ name: '', field: 'start_time', isTime: true }, { id: 0, start_time: row.start_time });
        },
        getColorOfMetricGroup(metricGroup) {
            if (!metricGroup.metricIds)
                return 'none';
            if (metricGroup.metricIds.every(r => this.class_metric_ids_data.includes(r)))
                return 'primary';
            if (metricGroup.metricIds.every(r => !this.class_metric_ids_data.includes(r)))
                return 'none';
            return 'grey';
        },
        handleMetricGroupBtnClick(metricGroup) {
            if (metricGroup.metricIds.every((r) => this.class_metric_ids_data.includes(r))) {
                this.class_metric_ids_data = this.class_metric_ids_data.filter(r => !metricGroup.metricIds.includes(r));
            }
            else {
                this.class_metric_ids_data = uniq([...this.class_metric_ids_data, ...metricGroup.metricIds]);
            }
        },
        selectOnlyThisMetricGroup(metricGroup) {
            this.class_metric_ids_data = metricGroup.metricIds;
        }
    }
});
